export const vitalMonitoringChartCalender_style = {};
